export const numberCommaFormatter = new Intl.NumberFormat([], { maximumFractionDigits: 0 }) // default to user locale
